import { createClient } from '@supabase/supabase-js'

export const DEFAULT_SUPABASE_URL = 'https://spb-bp1189e3cdewfte7.supabase.opentrust.net'
export const DEFAULT_SUPABASE_ANON_KEY =
  'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiYW5vbiIsInJlZiI6InNwYi1icDExODllM2NkZXdmdGU3IiwiaXNzIjoic3VwYWJhc2UiLCJpYXQiOjE3NzUwMzE2OTQsImV4cCI6MjA5MDYwNzY5NH0.Witdeq_-Fafmst8EG251pMdnKYdGDizXhvWthyt0xyk'
export const CLONE_SUPABASE_URL = 'https://ettptsazhwkunepoaorc.supabase.co'
export const CLONE_SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV0dHB0c2F6aHdrdW5lcG9hb3JjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkwMjkwMDcsImV4cCI6MjA5NDYwNTAwN30.DqdbyG-34c6iH6fVOk0PNGVgKekWYf5652jKLdUXUH0'

const CLONE_HOSTS = new Set([
  'awalong-new.pages.dev',
  '99521a1d.awalong-new.pages.dev',
])

const isOriginalOrLocalHost = (() => {
  if (typeof window === 'undefined') return false

  const host = window.location.hostname
  return (
    host === '8td5idtyk6.ai-app.pub' ||
    host === 'localhost' ||
    host === '127.0.0.1'
  )
})()

const isCloneHost = (() => {
  if (typeof window === 'undefined') return false
  return CLONE_HOSTS.has(window.location.hostname)
})()

export function getSupabaseRuntimeConfig() {
  const envUrl = import.meta.env.VITE_SUPABASE_URL
  const envKey =
    import.meta.env.VITE_SUPABASE_ANON_KEY || (window as any).__SUPABASE_ANON_KEY__

  if (envUrl && envKey) {
    return { url: envUrl, key: envKey }
  }

  if (isCloneHost) {
    return { url: CLONE_SUPABASE_URL, key: CLONE_SUPABASE_ANON_KEY }
  }

  if (isOriginalOrLocalHost) {
    return { url: DEFAULT_SUPABASE_URL, key: DEFAULT_SUPABASE_ANON_KEY }
  }

  return { url: '', key: '' }
}

const { url: supabaseUrl, key: supabaseKey } = getSupabaseRuntimeConfig()

export const hasSupabaseConfig = Boolean(supabaseUrl && supabaseKey)

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.invalid',
  supabaseKey ||
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzAwMDAwMDAwLCJleHAiOjQxMDAwMDAwMDB9.placeholder-signature'
)

// Auth bootstrap helper
let authReadyPromise: Promise<void> | null = null

export function waitForSupabaseAuthReady() {
  if (!authReadyPromise) {
    authReadyPromise = (async () => {
      const { data } = await supabase.auth.getSession()
      if (data.session) return

      await new Promise<void>((resolve) => {
        const timeout = window.setTimeout(resolve, 1500)
        const {
          data: { subscription },
        } = supabase.auth.onAuthStateChange((_event, session) => {
          if (session) {
            window.clearTimeout(timeout)
            subscription.unsubscribe()
            resolve()
          }
        })
      })
    })()
  }

  return authReadyPromise
}

;(window as any).supabase = supabase
